var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aj-adjust-font-size"},[_c('span',[_vm._v("字体大小")]),_c('ul',{on:{"click":_vm.onClk}},[_vm._m(0),_vm._m(1),_vm._m(2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('label',[_c('input',{attrs:{"type":"radio","name":"fontSize"}}),_vm._v(" 小")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('label',[_c('input',{attrs:{"type":"radio","name":"fontSize"}}),_vm._v(" 中")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('label',[_c('input',{attrs:{"type":"radio","name":"fontSize"}}),_vm._v(" 大")])])
}]

export { render, staticRenderFns }